import React, { useState } from 'react';
import { Box, Container, Grid, Typography, Card, CardContent, Collapse } from '@mui/material';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import LandingNavbar from './LandingPageNavBar';

const services = [
  {
    title: 'Supported Living',
    description:
      'Flexible support in individual or shared housing that scales from a few hours a week to 24/7 care.',
    icon: <VolunteerActivismIcon fontSize="large" />,
  },
  {
    title: 'Domiciliary Care',
    description:
      'Tailored packages for medication support, hygiene, mobility, and daily living—all delivered at home.',
    icon: <HealthAndSafetyIcon fontSize="large" />,
  },
  {
    title: 'Complex Care Support',
    description:
      'Specialist help for people with learning disabilities, autism, and complex medical needs.',
    icon: <FaceRetouchingNaturalIcon fontSize="large" />,
  },
  {
    title: 'Community Integration',
    description:
      'Life-skills coaching, education, and social opportunities that promote independence and confidence.',
    icon: <Diversity3Icon fontSize="large" />,
  },
];

const ServicesPage = () => {
  const [expandedCard, setExpandedCard] = useState(null);

  return (
    <>
      <LandingNavbar />
      <Box sx={{ bgcolor: 'rgba(142,81,255,0.85)', color: '#fff', pt: 16, pb: 12, px: 3 }}>
        <Container maxWidth="md">
          <Typography variant="overline" color="rgba(255,255,255,0.7)">
            Our Services
          </Typography>
          <Typography variant="h3" fontWeight={700} gutterBottom>
            Specialist Care & Support
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9 }}>
            Brought to life by multidisciplinary clinicians, nurses, and support practitioners who
            blend compassion with evidence-based practice.
          </Typography>
        </Container>
      </Box>

      <Box sx={{ py: 10, bgcolor: '#f5f6fb' }}>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            {services.map((service, idx) => (
              <Grid item xs={12} md={6} key={service.title}>
                <Card
                  onClick={() => setExpandedCard(expandedCard === idx ? null : idx)}
                  sx={{
                    borderRadius: 4,
                    p: 2,
                    minHeight: 140,
                    maxWidth: 360,
                    boxShadow: '0 20px 35px rgba(11,13,33,0.08)',
                    cursor: 'pointer',
                    mx: 'auto',
                  }}
                >
                  <CardContent>
                    <Box sx={{ color: '#8E51FF', mb: 1 }}>{service.icon}</Box>
                    <Typography variant="h6" fontWeight={700}>
                      {service.title}
                    </Typography>
                    <Collapse in={expandedCard === idx}>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        {service.description}
                      </Typography>
                    </Collapse>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default ServicesPage;
